import { render } from "./ComponentReferralMoment.vue?vue&type=template&id=8773098e&scoped=true"
import script from "./ComponentReferralMoment.vue?vue&type=script&lang=js"
export * from "./ComponentReferralMoment.vue?vue&type=script&lang=js"

import "./ComponentReferralMoment.vue?vue&type=style&index=0&id=8773098e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8773098e"]])

export default __exports__